import helpers from '../helpers';
import verifiers from '../verifiers';

class LABColor {
  constructor(lightness, a, b, alpha = 1) {
    this.lightness = lightness;
    this.a = a;
    this.b = b;
    this.alpha = alpha;
    helpers.checkRange(lightness, Number.MAX_VALUE, 'lightness');
    helpers.checkRange(alpha, 1, 'alpha');
  }

  equals({ lightness, a, b, alpha }) {
    const { isShadesEqual } = verifiers;

    return (
      isShadesEqual(this.lightness, lightness) &&
      isShadesEqual(this.a, a) &&
      isShadesEqual(this.b, b) &&
      isShadesEqual(this.alpha, alpha)
    );
  }
}

export default LABColor;
